import React, { useState } from 'react';
import { Lock, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function ZlatiArhivPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', {
      email,
      password
    });
  };
  return <div className="relative min-h-screen w-full bg-black" data-id="element-126">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1518998053901-5348d3961a04?q=80&w=2874&auto=format&fit=crop")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'brightness(0.3)'
    }} data-id="element-127" />

      {/* Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/60 via-black/40 to-black/80" data-id="element-128" />

      {/* Back Button */}
      <div className="absolute top-0 left-0 right-0 z-30 px-4 sm:px-6 lg:px-8 py-4 sm:py-5" data-id="element-129">
        <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300" data-id="element-130">
          <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-131" />
          <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest" data-id="element-132">
            Nazaj
          </span>
        </Link>
      </div>

      {/* Content */}
      <div className="relative z-20 flex min-h-screen flex-col items-center justify-center px-4 py-16 sm:py-20" data-id="element-133">
        <div className="w-full max-w-sm sm:max-w-md" data-id="element-134">
          {/* Lock Icon */}
          <div className="mb-6 sm:mb-8 flex justify-center" data-id="element-135">
            <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-full border border-neutral-700 bg-neutral-900/80 backdrop-blur-sm" data-id="element-136">
              <Lock className="h-6 w-6 sm:h-8 sm:w-8 text-white" data-id="element-137" />
            </div>
          </div>

          {/* Title */}
          <div className="mb-8 sm:mb-10 text-center" data-id="element-138">
            <h1 className="text-2xl sm:text-3xl font-light text-white sm:text-4xl mb-2" data-id="element-139">
              Zlati{' '}
              <span className="font-serif italic text-neutral-400" data-id="element-140">arhiv</span>
            </h1>
            <p className="text-base sm:text-lg font-light text-neutral-400 mt-3 sm:mt-4 px-4" data-id="element-141">
              Tukaj imam zaklenjene najine spomine.
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6" data-id="element-142">
            <Input label="E-pošta" type="email" placeholder="vas@email.si" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-143" />
            <Input label="Geslo" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-144" />
            <div className="pt-2 sm:pt-4" data-id="element-145">
              <Button type="submit" variant="primary" className="w-full" data-id="element-146">
                Vstopi
              </Button>
            </div>
          </form>

          {/* Help Text */}
          <p className="mt-6 sm:mt-8 text-center text-xs sm:text-sm text-neutral-500 px-4" data-id="element-147">
            Geslo ste prejeli ob naročilu fotografij.
          </p>
        </div>
      </div>
    </div>;
}